<template>
    <v-lazy v-model="intersected" :min-height="size" :min-width="size" :options="{ 'threshold': 0.1 }">
        <v-card :width="size" :height="size" class="d-flex align-center justify-center" flat color="transparent">
            <DropPad :disabled="!editable" @fileDrop="handleFileDrop"
                @click="openPickerOnClick ? clickFileInput() : $emit('click')" accept="image/png, image/jpeg">
                <v-img v-if="localfilesrc" :height="size" :width="size" contain :src="localfilesrc">
                </v-img>
                <v-img v-else-if="(relativePath || src) && !imgLoadError" :height="size" :width="size" contain
                    :src="src || imgurl()" @error="imgLoadError = true">
                </v-img>
                <v-tooltip v-else-if="imgLoadError" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" :size="size * 0.8" color="error lighten-3"
                            v-text="'mdi-image-off'">
                        </v-icon>
                    </template>
                    <span>{{ $t('servicesystem.common_objects.fallbackterms.failed_to_load_image') }}</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" :size="size * 0.8" color="disabled" v-text="fallbackIcon">
                        </v-icon>
                    </template>
                    <span>{{ $t('servicesystem.common_objects.fallbackterms.no_image') }}</span>
                </v-tooltip>
            </DropPad>
            <v-file-input v-show="false" v-model="uploadFile" ref="fileinput" color="primary"
                accept="image/png, image/jpeg">
                <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="primary" dark label>
                        {{ text }}
                    </v-chip>
                </template>
            </v-file-input>
        </v-card>
    </v-lazy>
</template>

<script>
import DropPad from "@/components/SingleUse/DropPad.vue";

export default {
    name: "QImage2",
    props: {
        size: Number,
        relativePath: String,
        fallbackIcon: String,
        editable: Boolean,
        openPickerOnClick: {
            type: Boolean,
            default: false,
        },
        src: String
    },
    components: {
        DropPad,
    },
    mixins: [],

    data() {
        return {
            intersected: false,
            path: null,
            imgLoadError: false,
            uploadFile: null,
            localfilesrc: null,
        };
    },

    mounted() {

    },

    methods: {
        handleFileDrop(file) {
            if (this.editable) {
                this.uploadFile = file;
            }
        },

        clickFileInput() {
            const elem = this.$refs.fileinput.$refs.input

            elem.click()
        },

        createImage(file) {
            const reader = new FileReader();
            reader.onload = e => {
                this.localfilesrc = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        onFileChange(file) {
            if (file) {
                this.createImage(file);
            }
            else {
                this.localfilesrc = null;
            }
            //console.log('File', file);
            this.$emit('File', file);
        },

        imgurl() {
            var baseurl = process.env.NODE_ENV === 'production' ? window.location.origin : 'https://test1.qwips.net';
            //console.log('imgurl', baseurl + "/api2/resource/?relativePath=" + this.relativePath);
            var rp = this.relativePath.replace("/api2/resource/?relativePath=", '');
            return baseurl + "/api2/resource/?relativePath=" + rp;
        },
    },

    computed: {

    },

    watch: {
        relativePath: function (val) {
            //console.log('path changed');
            if (val) {
                this.uploadFile = null;
            }
        },

        uploadFile: function (val) {
            this.onFileChange(val);
        },
    },
};
</script>